import React from 'react';
import {
  MDBCard,
  MDBCardImage,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBRow,
  MDBCol
} from 'mdb-react-ui-kit';
import { spacing } from '@mui/system';
import FYP from "../Images/multi-vendor-store.jpeg"
import counter from "../Images/counter.png"
import sign from "../Images/sign.png"
import chat from "../Images/chat.jpeg"

export default function App() {
  return (
    <MDBRow className='row-cols-1 row-cols-md-3 g-4 ms-5 '>
      <MDBCol>
        <MDBCard className='h-100 w-75 mt-5 px-2'>
          <MDBCardImage
            src={FYP}
            alt='...'
            position='top'
            style={{height:"auto"}}
          />
          <MDBCardBody>
            <MDBCardTitle>FYP Medicart</MDBCardTitle>
            <MDBCardText>
              This is a Multi-vendor store that is used to allow different customers to purchase products from different pharmacies and allow phamrmacy owners to add medicines in the their pharmacies.
            </MDBCardText>
            <a href="https://github.com/kingzing89" target='_blank' class="stretched-link">Go to Github</a>
          </MDBCardBody>
        </MDBCard>
      </MDBCol>
      <MDBCol>
        <MDBCard className='h-100 w-75 mt-5 px-2'>
          <MDBCardImage
            src={counter}
            alt='...'
            position='top'
            style={{height:"auto"}}
          />
          <MDBCardBody>
            <MDBCardTitle>React-Counter</MDBCardTitle>
            <MDBCardText>This is a react project that is used to increment or decrement a counter , including reseting a counter and it has a conditional statement which prevents the counter value from going below 0</MDBCardText>
            <a href="https://github.com/kingzing89" target='_blank' class="stretched-link">Go to Github</a>
          </MDBCardBody>
        </MDBCard>
      </MDBCol>
      <MDBCol>
        <MDBCard className='h-100 w-75 mt-5 px-2'>
          <MDBCardImage
            src={sign}
            alt='...'
            position='top'
            style={{height:"auto"}}
          />
          <MDBCardBody>
            <MDBCardTitle>AI Sign Language </MDBCardTitle>
            <MDBCardText>
              Created a Sign Language App using the ASL library that is used to detect hand gestures for all aphabets and certain words
            </MDBCardText>
            <a href="https://github.com/kingzing89" target='_blank' class="stretched-link">Go to Github</a>
          </MDBCardBody>
        </MDBCard>
      </MDBCol>
      <MDBCol>
        <MDBCard className='h-100 w-75 mt-5 px-2'>
          <MDBCardImage
            src={chat}
            alt='...'
            position='top'
            style={{height:"auto"}}
          />
          <MDBCardBody>
            <MDBCardTitle>Chat website</MDBCardTitle>
            <MDBCardText>
              Created a Mern Stack app using Socket.io and Node.js Server, It allows 2 users to communicate with each other using different sockets.
            </MDBCardText>
            <a href="https://github.com/kingzing89" target='_blank' class="stretched-link">Go to Github</a>
          </MDBCardBody>
        </MDBCard>
      </MDBCol>
    </MDBRow>
  );
}